import React from "react";

const Intro = () => {
  return (
    <section className="intro-section d-flex align-items-start">
      <div className="intro-background" />
      <div className="container">
        <div className="intro-content">
          <p className="ps-4 pt-md-5 pt-4 mt-md-4">
            Juntos creamos <br />
            tranquilidad
          </p>
        </div>
      </div>
    </section>
  );
};

export default Intro;
